import styled from "styled-components";
import { whiteBgOnClickAnim, scaleOnClickAnim } from "../../animations";

export const BallContainer = styled.div`
  display: grid;
  grid-template-columns: auto auto auto auto auto;
  grid-row-gap: 8px;
  grid-column-gap: 8px;
  margin: 0px auto 24px;
  will-change: transform;
  scrollbar-width: none;
`;

export const BetInfoBox = styled.div`
  padding: 20px 12px 0 12px;
  margin: 24px auto;
  background: rgba(0, 0, 0, 0.1);
  margin-left: -12px;
  border-radius: 12px;
  width: 337px;
`;

export const TitleS = styled.div`
  font-size: 20px;
  font-weight: bold;
`;

export const SubTitle = styled.div`
  font-size: 20px;
  font-family: "GT America, regular";
  line-height: 1.4;
  padding-bottom: 24px;
  word-break: break-all;
  user-select: text;
`;

export const Button = styled.div`
  background: #ffb000;
  border: solid 3px #ffb000;
  border-radius: 38px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  color: #ff3920;
  text-transform: uppercase;
  font-size: 20px;
  position: relative;
  cursor: pointer;
  :after {
    content: "";
    position: absolute;
    height: 100%;
    width: 100%;
    transform: scale(1);
    background: #ffffff;
    border: solid 3px #ffffff;
    border-radius: 38px;
    right: 50%;
    bottom: 50%;
    transform: translate(50%, 50%);
    width: 100%;
    height: 100%;
    opacity: 0;
    animation: ${(p) => p.btnAnimation && whiteBgOnClickAnim};
    animation-duration: 0.5s;
  }
  animation: ${(p) => p.btnAnimation && scaleOnClickAnim};
  animation-duration: 0.5s;
`;
export const Loader = styled.div`
  width: 100%;
  height: calc(100% - 126px);
  display: flex;
  justify-content: center;
  align-items: center;
  p {
    font-size: 30px;
    color: #ffb000;
    display: flex;
    justify-content: center;
    align-items: baseline;
    text-transform: uppercase;
  }
  span {
    width: 7px;
    height: 7px;
    background: #ffb000;
    border-radius: 50%;
    margin: 0 5px;
    animation: loading 1.5s infinite;
    :nth-child(1) {
      animation-delay: 0s;
    }
    :nth-child(2) {
      animation-delay: 0.25s;
    }
    :nth-child(3) {
      animation-delay: 0.5s;
    }
  }
  @keyframes loading {
    0% {
      transform: scale(1);
      animation-timing-function: cubic-bezier(0.33, 0, 0, 1);
    }
    50% {
      transform: scale(0.1);
      animation-timing-function: cubic-bezier(0.33, 0, 0, 1);
    }
    100% {
      transform: scale(1);
    }
  }
`;